import {Calculator} from 'lucide-react'
import { Link } from 'react-router-dom'

const QUICK_LINKS = [
  // Gestation / Pregnancy
  "Jersey Cow Pregnancy Calculator",
  "Holstein Cow Gestation Calculator",
  "Highland Cow Pregnancy Calculator",
  "Beef Cattle Gestation Calculator",
  "Angus Cow Due Date Calculator",
  "Hereford Cattle Calving Calculator",
  "Simmental Gestation Calculator",
  "Charolais Calving Date Calculator",
  "Brahman Cow Pregnancy Calculator",
  "Guernsey Cattle Gestation Calculator",
  "Dairy Cow Pregnancy Calculator",
  "Cattle Birth Calculator",
  "Cow Due Date Calculator",
  "Calving Date Predictor",
  "Cow Breeding Date Calculator",
  "Cattle Pregnancy Duration Calculator",
  "Cow Delivery Date Calculator",
  // Feeding / Nutrition
  "Beef Cow Ration Calculator",
  "Dairy Cow Ration Calculator",
  "Cattle Feed Calculator",
  "Cow Nutrition Calculator",
  "Heifer Feed Ration Calculator",
  "Cattle Mineral Calculator",
  "Dairy Feed Cost Calculator",
  "Beef Cattle Nutrition Planner",
  // Weight / Growth
  "Cow Weight Calculator",
  "Cattle Weight Estimation Tool",
  "Calf Weight Gain Calculator",
  "Cattle Growth Rate Calculator",
  "Beef Cattle Weight Chart",
  "Dairy Cow Body Weight Calculator",
  // Breeding / Heat
  "Cattle Heat Cycle Calculator",
  "Cow Estrous Cycle Calculator",
  "Cattle Breeding Timing Calculator",
  "AI Breeding Date Calculator",
  "Cattle Conception Rate Calculator",
  "Cow Fertility Calculator",
  // Herd / Business
  "Cattle Herd Growth Calculator",
  "Cow Calf Profit Calculator",
  "Cattle Per Acre Calculator",
  "Cow Calf Cost of Production",
  "Cattle Stocking Rate Calculator",
  "Ranch Profitability Calculator",
  "Cattle Break-Even Calculator",
  "Livestock ROI Calculator",
  // Health
  "Cattle Medication Dosage Calculator",
  "Cow Body Condition Score Calculator",
  "Cattle Deworming Calculator",
  "Calf Scour Treatment Calculator",
  "Cattle Vaccination Schedule Calculator",
  "Cow Milk Production Calculator",
]

const QUICK_LINK_ROUTES: Record<string, string> = {
  "Cattle Per Acre Calculator": "/cattle-per-acre-calculator",
  "Cattle Stocking Rate Calculator": "/cattle-per-acre-calculator",
  "Cow Calf Profit Calculator": "/cow-calf-profit-calculator",
  "Ranch Profitability Calculator": "/cow-calf-profit-calculator",
  "Cattle Break-Even Calculator": "/cow-calf-profit-calculator",
  "Livestock ROI Calculator": "/cow-calf-profit-calculator",
  "Cow Calf Cost of Production": "/cow-calf-cost-of-production",
}

export default function QuickLinksFooter() {
  return (
    <footer className="bg-[#283618] text-[#B7E4C7]">
      {/* Quick Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="text-center mb-8">
          <h2 className="text-xl sm:text-2xl font-bold text-[#FEFAE0]" style={{ fontFamily: "'Merriweather', serif" }}>
            Quick Links — Livestock Calculators
          </h2>
          <p className="mt-2 text-sm text-[#B7E4C7]/70">
            Explore our full suite of cattle and livestock management tools
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5 max-w-5xl mx-auto">
          {QUICK_LINKS.map((link) => {
            const linkHref = QUICK_LINK_ROUTES[link] || "/#gestation-calculator"
            const isInternal = linkHref.startsWith("/") && !linkHref.startsWith("/#")
            if (isInternal) {
              return (
                <Link
                  key={link}
                  to={linkHref}
                  className="inline-block text-xs sm:text-sm px-3 py-1.5 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#40916C]/50 rounded-lg transition-all duration-200 hover:text-[#FEFAE0]"
                >
                  {link}
                </Link>
              )
            }
            return (
              <a
                key={link}
                href={linkHref}
                className="inline-block text-xs sm:text-sm px-3 py-1.5 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#40916C]/50 rounded-lg transition-all duration-200 hover:text-[#FEFAE0]"
              >
                {link}
              </a>
            )
          })}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-[#40916C] flex items-center justify-center">
                <Calculator className="w-4 h-4 text-[#FEFAE0]" />
              </div>
              <div>
                <span className="text-[#FEFAE0] font-bold text-sm" style={{ fontFamily: "'Merriweather', serif" }}>
                  CowCalculator.com
                </span>
              </div>
            </div>

            {/* Copyright */}
            <p className="text-xs text-[#B7E4C7]/50 text-center">
              &copy; {new Date().getFullYear()} CowCalculator.com — The Ultimate Livestock Utility Hub. All rights reserved.
            </p>

            {/* Links */}
            <div className="flex items-center gap-4 text-xs text-[#B7E4C7]/50">
              <a href="#" className="hover:text-[#FEFAE0] transition-colors">Privacy</a>
              <a href="#" className="hover:text-[#FEFAE0] transition-colors">Terms</a>
              <a href="#" className="hover:text-[#FEFAE0] transition-colors">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
